module.exports = "<svg id=\"36249feb-f159-48c7-a923-ff59bdacd4f8\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>location</title><path class=\"icon-fill\" d=\"M24.75.1A11.39,11.39,0,0,0,13.5,11.66a14.68,14.68,0,0,0,.91,4.63L24.77,38,35.13,16.29A14.61,14.61,0,0,0,36,11.66,11.42,11.42,0,0,0,24.75.1Zm0,6.52A4.74,4.74,0,1,1,20,11.36,4.74,4.74,0,0,1,24.77,6.62ZM13.5,30.93l-3,19H39l-3-19H29.48q-2.35,4.93-4.71,9.86-2.36-4.92-4.71-9.86Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/location-01.svg
// module id = 543
// module chunks = 1